import BaseValidator from 'services/validations/base-validator';

export default class KeyPlayerTierNotDuplicatedInBoostStatementTiersValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {ruleItem, ruleName, players} = this.dependencies;

        const keyPlayer = players.getPlayer(ruleItem.getKeyPlayer());

        if (!keyPlayer) {
            return;
        }

        const keyPlayerTier = String(keyPlayer.rosterPositionName);

        for (const boostStatement of ruleItem.getBoostStatements()) {
            const player = players.getPlayer(boostStatement.getBoostedPlayer());

            if (player && keyPlayerTier === String(player.rosterPositionName)) {
                this.addError(`Key player tier cannot be duplicated in ${ruleName}.`);
                return;
            }
        }
    }
}
